import { GridFilterItem } from "@mui/x-data-grid";

const SELECT_OPERATOR = "is";
const TEXT_OPERATOR = "contains";
const EMPTY_OPERATOR = "isEmpty";

export const FILTER_OPERATORS = {
  SELECT: SELECT_OPERATOR,
  TEXT: TEXT_OPERATOR,
};

// Sentinel value used by the assignee filter to represent "unassigned"
// (visualsAssignee IS NULL). Distinct from a real username so it can be
// passed through the same onChange(field, value) signature as free text.
export const ASSIGNEE_UNASSIGNED = "__unassigned__";

export function parseFiltersByField(
  items: GridFilterItem[],
): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  items.forEach((item) => {
    if (item.value !== undefined) {
      if (!map[item.field]) {
        map[item.field] = [];
      }
      map[item.field].push(item.value);
    }
  });
  return map;
}

export function handleTextChange(
  field: string,
  val: string,
  currentItems: GridFilterItem[],
  onChange: (items: GridFilterItem[]) => void,
) {
  const newItems = currentItems.filter((item) => item.field !== field);
  if (val) {
    newItems.push({
      id: `${field}-text`,
      field,
      operator: TEXT_OPERATOR,
      value: val,
    });
  }
  onChange(newItems);
}

export function handleAssigneeChange(
  field: string,
  val: string,
  currentItems: GridFilterItem[],
  onChange: (items: GridFilterItem[]) => void,
) {
  const newItems = currentItems.filter((item) => item.field !== field);
  if (val === ASSIGNEE_UNASSIGNED) {
    newItems.push({
      id: `${field}-empty`,
      field,
      operator: EMPTY_OPERATOR,
    });
  } else if (val) {
    newItems.push({
      id: `${field}-text`,
      field,
      operator: TEXT_OPERATOR,
      value: val,
    });
  }
  onChange(newItems);
}

export function getAssigneeValue(
  field: string,
  items: GridFilterItem[],
): string {
  const item = items.find((i) => i.field === field);
  if (!item) {
    return "";
  }
  if (item.operator === EMPTY_OPERATOR) {
    return ASSIGNEE_UNASSIGNED;
  }
  return item.value ?? "";
}

export function handleSingleSelectChange(
  field: string,
  val: string,
  currentItems: GridFilterItem[],
  onChange: (items: GridFilterItem[]) => void,
) {
  const newItems = currentItems.filter((item) => item.field !== field);
  if (val) {
    newItems.push({
      id: `${field}-single`,
      field,
      operator: SELECT_OPERATOR,
      value: val,
    });
  }
  onChange(newItems);
}

export function handleMultiSelectChange(
  field: string,
  values: string[],
  currentItems: GridFilterItem[],
  onChange: (items: GridFilterItem[]) => void,
) {
  const newItems = currentItems.filter((item) => item.field !== field);
  const added: GridFilterItem[] = values.map((v) => ({
    id: `${field}-${v}`,
    field,
    operator: SELECT_OPERATOR,
    value: v,
  }));
  onChange([...newItems, ...added]);
}

export const handleCategoryChange = (
  field: string,
  val: string,
  items: GridFilterItem[],
  onChange: (items: GridFilterItem[]) => void,
) => {
  const newItems = items.filter(
    (item) => item.field !== field && item.field !== "subcategory",
  );

  if (val) {
    newItems.push({
      id: `${field}-single`,
      field,
      operator: "is",
      value: val,
    });
  }

  onChange(newItems);
};

export function getTextValue(
  field: string,
  filtersByField: Record<string, string[]>,
): string {
  return filtersByField[field]?.[0] ?? "";
}
